import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  mapMerchantsToFeaturedMerchants,
  getCorrectFeaturedMerchants
} from "@app/api/wp-page-fetcher/module-selector/module-mappers";
import { FeaturedMerchantsModule } from "@app/api/modules/featured-merchants/featured-merchants.module";
import { settingsState } from "@app/redux/reducers/settings";
import { merchantsState } from "@app/redux/reducers/merchants";
import { IOutFeaturedMerchantDTO } from "@app/core/new-merchant-card/featured-merchants.interface";
import { FeaturedLayout } from "@app/components/featured-layout/featured-layout";

import { MerchantCardWrapper } from "../merchant-card-wrapper/merchant-card-wrapper";

export interface IFeaturedMerchantsComponentProps {
  featuredMerchantsModule: FeaturedMerchantsModule;
}

export const FeaturedMerchants = (props: IFeaturedMerchantsComponentProps) => {
  const settings = useSelector(settingsState);
  const { platformId } = settings;
  const merchantsFromState = useSelector(merchantsState);
  const { currentMerchant } = merchantsFromState;

  const {
    title,
    subtitle,
    topCtaTitle,
    ctaButton,
    ctaDescription,
    featuredMerchants,
    isMerchantSinglePage,
    selectionChoice,
    merchantSelection,
    amountOfStores,
    filterIds,
    labelFilter,
    pageUrl
  } = props.featuredMerchantsModule;

  const [merchants, setMerchants] = useState<IOutFeaturedMerchantDTO[]>(featuredMerchants || []);
  const [merchantSingleFilters, setMerchantSingleFilters] = useState<string | undefined>(undefined);
  const merchantsToUse = merchants && merchants.length > 0 ? merchants : featuredMerchants;

  useEffect(() => {
    if (currentMerchant && isMerchantSinglePage) {
      const merchantFilterIds = currentMerchant.categories?.map((item) => item.id);
      const merchantFilters = merchantFilterIds?.join(";");
      setMerchantSingleFilters(merchantFilters);
      getMerchants(merchantFilters, true);
    } else {
      getMerchants(undefined, false);
    }
    setMerchantSingleFilters(undefined);
  }, [pageUrl]);

  const getMerchants = async (merchantFilters?: string, merchantSinglePage?: boolean): Promise<void> => {
    const newMerchants = await getCorrectFeaturedMerchants({
      platformId,
      limit: amountOfStores,
      filterIds,
      selectionChoice,
      merchantSelection,
      isMerchantSinglePage: merchantSinglePage,
      merchantSingleFilters: merchantFilters || merchantSingleFilters,
      labelFilter
    });

    setMerchants(mapMerchantsToFeaturedMerchants(newMerchants || []));
  };

  if (!merchantsToUse || merchantsToUse.length === 0) {
    return <></>;
  }

  return (
    <FeaturedLayout
      title={title}
      subtitle={subtitle}
      items={merchantsToUse}
      renderItem={(item) => <MerchantCardWrapper merchant={item} />}
      topCtaTitle={topCtaTitle}
      ctaCard={{
        title: ctaDescription,
        subtitle: ctaButton?.title,
        href: ctaButton?.url || ""
      }}
      mobileMaxItemAmt={props.featuredMerchantsModule.amountOfMerchantsMobile}
    />
  );
};
